import React, { useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import ImagePicker from "@/components/media/ImagePicker";
import { imgUrl } from "@/pages/curated/shared";

/** Tira de fotos reutilizada por actividades y hoteles del Curated Trip. */
export function CuratedPhotoStrip({ images = [], onChange, query = "", testid = "photos" }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      {images.map((u, i) => (
        <div key={`${u}-${i}`} className="group relative h-16 w-24 overflow-hidden rounded border bg-muted">
          <img src={imgUrl(u)} alt="" className="h-full w-full object-cover" />
          <button type="button" onClick={() => onChange(images.filter((_, j) => j !== i))} aria-label="Quitar foto"
            className="absolute right-0.5 top-0.5 hidden rounded-full bg-black/60 p-0.5 text-white group-hover:block" data-testid={`${testid}-remove-${i}`}>
            <X className="h-3 w-3" />
          </button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" className="h-16 w-24 flex-col gap-1 text-xs" onClick={() => setOpen(true)} data-testid={`${testid}-add`}>
        <ImagePlus className="h-4 w-4" /> Foto
      </Button>
      <ImagePicker open={open} onOpenChange={setOpen} multiple onSelect={(u) => onChange([...(images || []), u])} title="Añadir fotos" defaultQuery={query} />
    </div>
  );
}
